import { PopupKey } from "@builder/store/slices/popupSlice";
import TemplateLibrary from "./popups/TemplateLibrary";
import Conditions from "./popups/Conditions";
import PublishBuild from "@builder/components/app/Popup/popups/PublishBuild";
import Actions from "@builder/components/app/Popup/popups/Actions";
import Images from "@builder/components/app/Popup/popups/Images";
import Icons from "@builder/components/app/Popup/popups/Icons";
import ActionBuilder from "@builder/components/app/Popup/popups/ActionBuilder";
import DynamicDataPopup from "./popups/DynamicData";
import GlobalBlocks from "@builder/components/app/Popup/popups/GlobalBlock";
import LogoutPopup from "@builder/components/app/Popup/popups/Logout";
import FullDesignSets from "@builder/components/app/Popup/popups/FullDesignSets";
import OnboardComplete from "@builder/components/app/Popup/popups/OnboardComplete/OnboardComplete";

type PopupMap = {
    [key in PopupKey]: JSX.Element;
};

export const popupMap: PopupMap = {
    templateLibrary: <TemplateLibrary />,
    conditions: <Conditions />,
    icons: <Icons />,
    dynamicData: <DynamicDataPopup />,
    publishBuild: <PublishBuild />,
    actions: <Actions />,
    images: <Images />,
    actionBuilder: <ActionBuilder />,
    globalBlocks: <GlobalBlocks />,
    logout: <LogoutPopup />,
    fullDesignSets: <FullDesignSets />,
    onboardComplete: <OnboardComplete />
};
